module.exports = __webpack_public_path__ + "img/righthua_brown.5025ca0c.svg";